import { render, staticRenderFns } from "./CruiseItineraryDetail.vue?vue&type=template&id=4b3d0850&scoped=true"
import script from "./CruiseItineraryDetail.vue?vue&type=script&lang=js"
export * from "./CruiseItineraryDetail.vue?vue&type=script&lang=js"
import style0 from "./CruiseItineraryDetail.vue?vue&type=style&index=0&id=4b3d0850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3d0850",
  null
  
)

export default component.exports